import { render } from "./CategoryBanner.vue?vue&type=template&id=63b4b225&scoped=true"
import script from "./CategoryBanner.vue?vue&type=script&lang=js"
export * from "./CategoryBanner.vue?vue&type=script&lang=js"

import "./CategoryBanner.vue?vue&type=style&index=0&id=63b4b225&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b4b225"]])

export default __exports__